import { intersection } from 'lodash-es';

import {
  DispatchTripRead,
  PayerOrganizationRead,
} from 'src/common/external/bambi-api/bambiApi';

import { getPotentialMultiloadTripIds } from './getPotentialMultiloadTripIds';

export function getPotentialMultiloadCandidates(
  assignmentId: string,
  trip: DispatchTripRead,
  assignedTrips?: DispatchTripRead[],
  payers?: PayerOrganizationRead[]
) {
  const potentialMultiloadTripIds = getPotentialMultiloadTripIds(
    trip,
    [...(assignedTrips || [])],
    assignmentId,
    payers || []
  );
  const tripsAlreadyAssignedToAssignment = assignedTrips?.filter(
    (t) => t.assignment_id === assignmentId
  );
  const hasPotentialMultiloadTripsAssigned =
    Array.isArray(tripsAlreadyAssignedToAssignment) &&
    intersection(
      tripsAlreadyAssignedToAssignment.map((t) => t.id),
      potentialMultiloadTripIds
    ).length > 0;

  return {
    potentialMultiloadTripIds,
    hasPotentialMultiloadTripsAssigned,
  };
}
